type PickupLocationParts = {
  title?: string | null
  address?: string | null
  phone?: string | null
}

const clean = (value?: string | null) => (value ?? '').trim()

export const pickupLocationParts = ({
  title,
  address,
  phone,
}: PickupLocationParts) => ({
  place: [title, address].map(clean).filter(Boolean).join(', '),
  phone: clean(phone),
})

export const formatPickupLocation = (parts: PickupLocationParts) => {
  const { place, phone } = pickupLocationParts(parts)
  return phone ? `${place} · ${phone}` : place
}
